module.exports = __webpack_public_path__ + "static/media/landing-photo.1d18636f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-photo.jpg
// module id = 469
// module chunks = 0